import React from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "../../../../utilities/classNames";

var TextareaControl = function TextareaControl(_ref) {
  var defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      id = _ref.id,
      labelText = _ref.labelText,
      name = _ref.name,
      onChange = _ref.onChange,
      required = _ref.required,
      value = _ref.value,
      _ref$optionalText = _ref.optionalText,
      optionalText = _ref$optionalText === void 0 ? "(Optional)" : _ref$optionalText;
  var getClassName = getClassNameFactory(TextareaControl.displayName);
  /* eslint-disable jsx-a11y/label-has-for */

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("label", {
    className: getClassName({
      descendantName: "label"
    }),
    htmlFor: id
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "labelText"
    })
  }, labelText, " ", !required && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "optional"
    })
  }, optionalText)), /*#__PURE__*/React.createElement("textarea", {
    className: getClassName({
      descendantName: "input"
    }),
    defaultValue: defaultValue,
    disabled: disabled,
    id: id,
    name: name,
    onChange: onChange,
    value: value,
    "aria-required": required
  })));
};
/* eslint-disable max-len */


TextareaControl.propTypes = {
  /**
   * Initialize <textarea> with a value
   */
  defaultValue: PropTypes.string,

  /**
   * Disable the <textarea>
   */
  disabled: PropTypes.bool,

  /**
   * Id attribute for <textarea> (and <label> `for` attribute)
   */
  id: PropTypes.string.isRequired,

  /**
   * Text for <label>
   */
  labelText: PropTypes.string.isRequired,

  /**
   * Name attribute for <textarea>, required for serialisation
   */
  name: PropTypes.string.isRequired,

  /**
   * Listen for changes on the <textarea>.
   */
  onChange: PropTypes.func,

  /**
   * Set <textarea> to be required
   */
  required: PropTypes.bool,

  /**
   * Explicitly set the value of the <textarea>. Will switch to controlled mode
   */
  value: PropTypes.string,

  /**
   * render custom optionalText
   */
  optionalText: PropTypes.string
};
/* eslint-enable max-len */

TextareaControl.displayName = "Form.TextareaControl";
export default TextareaControl;